<template>
  <div
    class="tooth"
    v-click-outside="onCloseMenu">
    <tooth-popover-menu
      top
      v-bind:flip="flip"
      v-bind:value="isShowMenu">
      <template slot="trigger">
        <div class="tooth__body">
          <svg
            v-if="!isDeleted"
            class="tooth-down-8 tooth__parts"
            v-bind:class="{ flip }"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 72 183">
            <g v-if="isDiagnosisImplant" id="implant">
              <rect width="25.564" height="13.231" x="23.666" y="109.184" fill="#A8BEC5" stroke="#778F9F" rx="1.397" />
              <path fill="#778F9F" stroke="#778F9F" stroke-width=".949" d="M46.864 126.274H26.032l4.836 55.777h11.904l4.092-55.777Z" />
              <rect width="29.845" height="4.309" x="-.474" y=".474" fill="#A8BEC5" stroke="#778F9F" stroke-width=".949" rx="1.146" transform="matrix(1 0 0 -1 22 127.223)" />
              <path fill="#A8BEC5" stroke="#778F9F" stroke-linecap="round" stroke-width=".949" d="M23.368 130.933a1.679 1.679 0 0 1 1.94-1.372l23.52 4.032.168.037a1.68 1.68 0 0 1-.736 3.274l-23.52-4.032a1.68 1.68 0 0 1-1.372-1.939Zm2.434 5.266.17.019 22.177 3.697a1.68 1.68 0 1 1-.553 3.314l-22.176-3.696-.168-.037a1.68 1.68 0 0 1 .55-3.297Zm.339 6.325.172.021 21.84 3.695a1.681 1.681 0 0 1-.56 3.313l-21.842-3.695-.168-.037a1.682 1.682 0 0 1 .558-3.297Zm-.758 7.729a1.68 1.68 0 0 1 1.928-1.386l20.497 3.36a1.68 1.68 0 1 1-.544 3.315l-20.496-3.36a1.68 1.68 0 0 1-1.386-1.929Zm2.141 4.925.17.024 19.153 3.695a1.68 1.68 0 0 1-.636 3.3L27.058 158.5l-.167-.041a1.68 1.68 0 0 1 .633-3.281Zm.671 5.988.17.024 17.472 3.36.168.041a1.68 1.68 0 0 1-.802 3.258L27.73 164.49l-.168-.041a1.68 1.68 0 0 1 .632-3.283Zm.295 6.658.17.019 16.128 2.689a1.68 1.68 0 1 1-.552 3.314l-16.128-2.688-.168-.037a1.68 1.68 0 0 1 .55-3.297Zm.39 6.329.17.025 15.12 3.024.167.042a1.681 1.681 0 0 1-.827 3.253l-15.12-3.024-.167-.042a1.68 1.68 0 0 1 .656-3.278Z" />
            </g>
            <g v-else>
              <path
                v-if="isShowPart('root_1')"
                d="M55.5026 114.486V106.392C55.5026 106.321 55.445 106.264 55.3741 106.264L36.8716 108.061V117.568V128.103C37.6012 128.103 38.2831 128.447 38.6471 129.079C38.6807 129.137 38.7089 129.188 38.7292 129.226L39.1048 129.936C39.5006 130.683 39.821 131.468 40.0613 132.279L40.7277 134.529L41.7555 138.768L42.6549 143.779L43.2973 148.533L44.0681 153.543L44.839 159.068L45.7383 163.693L46.6377 168.832L47.3779 171.23C47.4469 171.477 47.5572 171.71 47.704 171.92L47.9447 172.263C48.2185 172.655 48.6658 172.887 49.1432 172.887C49.5579 172.887 49.9532 172.711 50.2306 172.403L50.6209 171.97C50.8393 171.727 51.0131 171.576 51.1343 171.273L51.5198 170.374C51.7664 169.757 52.1069 169.149 52.2527 168.501L53.19 164.335L54.2178 156.37L54.7317 149.303L55.2456 143.008L55.5026 134.529V114.486Z"
                v-bind:class="{ selected: isSelected('root_1') }"
                v-bind:fill="partColor['root_1'] || '#FFF'"
                v-on:click="onClick('root_1', $event)"
                v-on:keydown="onClick('root_1', $event)" />
              <path
                v-if="isShowPart('root_2')"
                d="M21.2961 179.399L21.8133 180.951C21.9175 181.263 22.0691 181.558 22.263 181.825C22.725 182.46 23.463 182.836 24.2485 182.836H24.718C24.9346 182.836 25.1438 182.757 25.3067 182.614L25.5036 182.442C25.8826 182.111 26.1692 181.687 26.3355 181.211L26.9811 179.367L27.8804 176.412L28.5228 173.071L28.9082 169.474L29.4221 164.335L29.8076 160.866L30.193 156.369L30.5784 152.258L31.2208 147.119L31.7347 142.109L32.2486 138.254L33.0195 135.171L33.5466 132.535C33.6232 132.152 33.7395 131.778 33.8934 131.419C34.4919 130.022 35.5499 128.873 36.8918 128.16L37.0004 128.103V107.677L17.0884 110.246V114.486L17.4738 131.316L17.8592 145.449L18.2447 151.744L18.7586 159.581L19.144 164.335L19.6579 170.373L20.7647 177.236C20.8832 177.97 21.0609 178.694 21.2961 179.399Z"
                v-bind:class="{ selected: isSelected('root_2') }"
                v-bind:fill="partColor['root_2'] || '#FFF'"
                v-on:click="onClick('root_2', $event)"
                v-on:keydown="onClick('root_2', $event)" />
              <path
                v-if="isShowPart('root_2')"
                d="M24.2893 121.486L24.1855 121.512C23.7492 121.621 23.3621 121.873 23.086 122.228C22.7803 122.621 22.622 123.105 22.638 123.603C22.967 133.832 23.262 152.117 23.7545 155.003C23.7647 155.064 23.7837 155.112 23.8124 155.166C23.9757 155.472 24.4064 155.52 24.5959 155.229C24.6393 155.163 24.6679 155.11 24.6684 155.084C24.9028 144.049 27.8728 129.74 29.679 123.608L29.8246 122.953C29.8957 122.632 29.8331 122.297 29.6511 122.024C29.5027 121.801 29.2842 121.634 29.0303 121.55L28.6512 121.423C28.0524 121.338 27.4483 121.295 26.8434 121.295H25.8247L24.797 121.398C24.6259 121.415 24.4562 121.444 24.2893 121.486Z"
                v-bind:class="{ selected: isSelected('cheek_canal') }"
                v-bind:fill="partColor['cheek_canal'] || '#FF82BE'"
                v-on:click="onClick('cheek_canal', $event)"
                v-on:keydown="onClick('cheek_canal', $event)" />
              <path
                v-if="isShowPart('root_1')"
                d="M46.95 114.44L47.0909 114.466C47.6091 114.563 48.0805 114.829 48.4302 115.224C48.8239 115.668 49.0473 116.232 49.0621 116.825C49.3633 128.86 50.2494 150.332 49.8593 153.763C49.851 153.837 49.8312 153.896 49.8 153.963C49.6257 154.335 49.1213 154.421 48.8747 154.092C48.8171 154.016 48.7784 153.954 48.776 153.924C47.7494 140.98 43.2429 124.38 40.6763 117.302L40.4605 116.549C40.3529 116.174 40.4051 115.771 40.6046 115.436C40.7648 115.167 41.01 114.959 41.3015 114.844L41.7525 114.666L42.8149 114.454L45.1101 114.321L46.3431 114.371C46.5468 114.38 46.7496 114.403 46.95 114.44Z"
                v-bind:class="{ selected: isSelected('lingual_canal') }"
                v-bind:fill="partColor['lingual_canal'] || '#FF82BE'"
                v-on:click="onClick('lingual_canal', $event)"
                v-on:keydown="onClick('lingual_canal', $event)" />
            </g>
            <path
              v-if="!isDiagnosisImplant || hasCrownOnImplant"
              d="M19.7589 113.478L17.3274 112.234C16.4762 110.303 15.8159 108.294 15.3557 106.234L15.1518 105.322L14.5119 100.759L14.1984 98.1345C14.0666 97.0312 14.0673 95.9162 14.2005 94.8132L14.2291 94.5762C14.332 93.7239 14.528 92.8855 14.8135 92.0759L15.1388 91.1533C15.3172 90.6476 15.568 90.1704 15.8834 89.7368L16.2498 89.233C16.6195 88.7247 17.1243 88.3302 17.7068 88.0942C18.4528 87.792 19.2825 87.7673 20.0451 88.0248L20.9107 88.317L20.9374 88.3278C21.5815 88.5887 22.2969 88.6143 22.958 88.4001C23.1285 88.3448 23.2936 88.2741 23.4513 88.189L25.2619 87.211L27.1815 86.5198L28.9732 86.105L29.8013 85.9772C30.4428 85.8782 31.0908 85.8285 31.7398 85.8285C32.5385 85.8285 33.3354 85.9038 34.1199 86.0534L35.1161 86.2433L37.0357 86.7963L38.6457 87.1032C39.0219 87.1749 39.4041 87.211 39.7871 87.211C40.5898 87.211 41.3845 87.0525 42.1258 86.7445L42.6667 86.5198L46.25 85.552L49.3214 84.999H51.497L53.2887 85.552L54.6964 86.5198L55.7202 87.4875L56.6161 89.0082L57 91.4967V93.7087V95.6442V99.6534L56.6161 102.418L55.8482 106.151L55.6289 107.691C55.6047 107.861 55.5458 108.024 55.4557 108.17C55.3767 108.298 55.2754 108.41 55.1564 108.502L54.3038 109.16C53.8013 109.548 53.237 109.848 52.6347 110.048C52.1347 110.214 51.6138 110.31 51.0874 110.332L48.5536 110.437L44.3304 110.713L40.4911 111.405L37.0357 112.511L32.4286 113.893L28.8871 114.698C28.0088 114.898 27.1109 114.999 26.2101 114.999C25.2402 114.999 24.2739 114.882 23.332 114.651L21.9345 114.308L19.7589 113.478Z"
              v-bind:class="{ selected: isSelected('crown') }"
              v-bind:fill="partColor['crown'] || '#FFF'"
              v-on:click="onClick('crown', $event)"
              v-on:keydown="onClick('crown', $event)" />
          </svg>
          <svg
            v-else-if="isBoneImplant"
            class="tooth-down-8 tooth__parts"
            v-bind:class="{ flip }"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 72 183">
            <g id="implant">
              <rect width="25.564" height="13.231" x="23.666" y="109.184" fill="#A8BEC5" stroke="#778F9F" rx="1.397" />
              <path fill="#778F9F" stroke="#778F9F" stroke-width=".949" d="M46.864 126.274H26.032l4.836 55.777h11.904l4.092-55.777Z" />
              <rect width="29.845" height="4.309" x="-.474" y=".474" fill="#A8BEC5" stroke="#778F9F" stroke-width=".949" rx="1.146" transform="matrix(1 0 0 -1 22 127.223)" />
              <path fill="#A8BEC5" stroke="#778F9F" stroke-linecap="round" stroke-width=".949" d="M23.368 130.933a1.679 1.679 0 0 1 1.94-1.372l23.52 4.032.168.037a1.68 1.68 0 0 1-.736 3.274l-23.52-4.032a1.68 1.68 0 0 1-1.372-1.939Zm2.434 5.266.17.019 22.177 3.697a1.68 1.68 0 1 1-.553 3.314l-22.176-3.696-.168-.037a1.68 1.68 0 0 1 .55-3.297Zm.339 6.325.172.021 21.84 3.695a1.681 1.681 0 0 1-.56 3.313l-21.842-3.695-.168-.037a1.682 1.682 0 0 1 .558-3.297Zm-.758 7.729a1.68 1.68 0 0 1 1.928-1.386l20.497 3.36a1.68 1.68 0 1 1-.544 3.315l-20.496-3.36a1.68 1.68 0 0 1-1.386-1.929Zm2.141 4.925.17.024 19.153 3.695a1.68 1.68 0 0 1-.636 3.3L27.058 158.5l-.167-.041a1.68 1.68 0 0 1 .633-3.281Zm.671 5.988.17.024 17.472 3.36.168.041a1.68 1.68 0 0 1-.802 3.258L27.73 164.49l-.168-.041a1.68 1.68 0 0 1 .632-3.283Zm.295 6.658.17.019 16.128 2.689a1.68 1.68 0 1 1-.552 3.314l-16.128-2.688-.168-.037a1.68 1.68 0 0 1 .55-3.297Zm.39 6.329.17.025 15.12 3.024.167.042a1.681 1.681 0 0 1-.827 3.253l-15.12-3.024-.167-.042a1.68 1.68 0 0 1 .656-3.278Z" />
            </g>
            <path
              v-if="hasCrownOnImplant"
              d="M19.7589 113.478L17.3274 112.234C16.4762 110.303 15.8159 108.294 15.3557 106.234L15.1518 105.322L14.5119 100.759L14.1984 98.1345C14.0666 97.0312 14.0673 95.9162 14.2005 94.8132L14.2291 94.5762C14.332 93.7239 14.528 92.8855 14.8135 92.0759L15.1388 91.1533C15.3172 90.6476 15.568 90.1704 15.8834 89.7368L16.2498 89.233C16.6195 88.7247 17.1243 88.3302 17.7068 88.0942C18.4528 87.792 19.2825 87.7673 20.0451 88.0248L20.9107 88.317L20.9374 88.3278C21.5815 88.5887 22.2969 88.6143 22.958 88.4001C23.1285 88.3448 23.2936 88.2741 23.4513 88.189L25.2619 87.211L27.1815 86.5198L28.9732 86.105L29.8013 85.9772C30.4428 85.8782 31.0908 85.8285 31.7398 85.8285C32.5385 85.8285 33.3354 85.9038 34.1199 86.0534L35.1161 86.2433L37.0357 86.7963L38.6457 87.1032C39.0219 87.1749 39.4041 87.211 39.7871 87.211C40.5898 87.211 41.3845 87.0525 42.1258 86.7445L42.6667 86.5198L46.25 85.552L49.3214 84.999H51.497L53.2887 85.552L54.6964 86.5198L55.7202 87.4875L56.6161 89.0082L57 91.4967V93.7087V95.6442V99.6534L56.6161 102.418L55.8482 106.151L55.6289 107.691C55.6047 107.861 55.5458 108.024 55.4557 108.17C55.3767 108.298 55.2754 108.41 55.1564 108.502L54.3038 109.16C53.8013 109.548 53.237 109.848 52.6347 110.048C52.1347 110.214 51.6138 110.31 51.0874 110.332L48.5536 110.437L44.3304 110.713L40.4911 111.405L37.0357 112.511L32.4286 113.893L28.8871 114.698C28.0088 114.898 27.1109 114.999 26.2101 114.999C25.2402 114.999 24.2739 114.882 23.332 114.651L21.9345 114.308L19.7589 113.478Z"
              v-bind:class="{ selected: isSelected('crown') }"
              v-bind:fill="partColor['crown'] || '#FFF'"
              v-on:click="onClick('crown', $event)"
              v-on:keydown="onClick('crown', $event)" />
          </svg>
          <button
            class="tooth__body__all-tooth"
            type="button"
            v-on:click="onAllToothClick($event)" />
          <button
            class="tooth__body__gingiva"
            type="button"
            v-bind:class="{ [round]: true, selected: isSelected('gingiva') }"
            v-bind:style="{ 'background-color': partColor['gingiva'] || '#f4ddc1' }"
            v-on:click="onClick('gingiva', $event)" />
          <button
            class="tooth__body__bone"
            type="button"
            v-bind:class="{ [round]: true, selected: isSelected('bone') }"
            v-bind:style="{ 'background-color': partColor['bone'] || '#ffead2' }"
            v-on:click="onClick('bone', $event)" />
        </div>
      </template>
      <form-teeth-formula-diagnoses
        v-bind:class="{ 'disable-component': disabled }"
        v-bind:is-deleted="needDeleted"
        v-bind:part-list="partList"
        v-bind:has-implant="hasImplant"
        v-on:cancel="onCloseMenu"
        v-on:change-diagnoses="onChangeDiagnoses"
        v-on:change-tooth-deleted="onChangeToothDeleted"
        v-on:submit="onSubmit" />
    </tooth-popover-menu>
    <bottom-tooth-surface
      v-bind:surface="surface"
      v-bind:part-selected="partSelected"
      v-bind:selected-parts="selectedParts"
      v-bind:flip="flip"
      v-on:select="onClick" />
    <div class="tooth__number">{{ tooth.number }}</div>
  </div>
</template>
<script>
import toothMixin from '@/mixins/toothMixin';
import ToothPopoverMenu from '../ToothPopoverMenu.vue';
import FormTeethFormulaDiagnoses from '../FormTeethFormulaDiagnoses.vue';
import BottomToothSurface from '../BottomToothSurface.vue';

export default {
  components: {
    ToothPopoverMenu,
    FormTeethFormulaDiagnoses,
    BottomToothSurface,
  },
  computed: {
    /**
     * @description Список диагнозов частей зуба для исключения.
     * @type {Object.<string,string[]>}
     */
    excludePartDiagnosis() {
      const excluded = {};
      const filter = this.partSelected === 'all'
        ? this.filterBySelectedDiagnoses
        : this.filterByHiddenParts;
      const excludedParts = ['root_1', 'root_2'].filter(filter);
      if (excludedParts.length === 1) {
        const [root] = excludedParts;
        excluded[root] = ['root_deleted'];
      }
      return excluded;
    },
    round: ({ flip }) => (flip ? 'round-right' : 'round-left'),
  },
  mixins: [toothMixin],
  name: 'ToothDown8',
};
</script>

<style scoped>
.tooth {
  flex-direction: column-reverse;
}
.tooth__body {
  grid-template-rows: 30px 25px 66px;
}
.tooth__parts {
  top: auto;
  bottom: 17.28px;
}
.tooth__body__bone.round-left {
  border-radius: 0 0 0 20px;
}
.tooth__body__bone.round-right {
  border-radius: 0 0 20px 0;
}
.tooth__body__gingiva.round-left {
  border-radius: 10px 0 0 0;
}
.tooth__body__gingiva.round-right {
  border-radius: 0 10px 0 0;
}
</style>
